import { ViewModel, View, ObservableArray } from "binder"
import moment from "moment";
import { IPopup } from "src/common/userMainWindow/windowContainer/IPopup";
import { stringIsNullOrEmpty } from "src/common/utilities";
import { PhoneInputViewModel } from "src/common/utilities/phoneInput/phoneInput-viewModel";
import { CitySelectorViewModel } from "src/Financial/cityManipulation/cityManipulation-viewModel";
import { ProvinceSelectorViewModel } from "src/Financial/provinceManipulation/provinceManipulation-viewModel";
import { ServerConnection } from "src/server/serverConnection";
import { Customer, CustomerManipulationViewModel } from "../customerManipulation/customerManipulation-viewModel";
import { EditCustomerView } from "./editCustomer-view"
import { getAsBoolean } from "src/uicomponents/components/utilities";
import { CustomerSearchViewModel } from "src/arap/rawData/customerSelector-viewModel";
import { SearchCustomerViewModel } from "../searchCustomer/searchCustomer-viewModel";

export class EditCustomerViewModel extends ViewModel implements IPopup {
    constructor(parentViewModel: CustomerManipulationViewModel) {
        super(parentViewModel);
        this._typedParent = parentViewModel;
        this.monopolies = ObservableArray.create<MonopolyDistrict>();
        this.attributeValues = ObservableArray.create<CustomerAttributeValue>();
        this.citySelector = new CitySelectorViewModel(this);
        this.provinceSelector = new ProvinceSelectorViewModel(this);
        this.parentCustomerSelector = new SearchCustomerViewModel(this);
        this.hasParent = false;
        this.parentCustomerTitle = "مرجع انتخاب نشده است.";
        this.parentCustomerSelector.onSelectionChanged = async selectedCustomer => {
            if (selectedCustomer == null) {
                this.parentCustomerTitle = "مرجع انتخاب نشده است.";
            } else {
                this.parentCustomerTitle = selectedCustomer.title;
            }
        }
        this.provinceSelector.onSelectionChanged = x => {
            this.citySelector.provinceId = x?.id
        };
        this.phoneInput = new PhoneInputViewModel(this);
    }

    closePopup(resultCode: string = null) {
    }

    GetDefaultView(): View<ViewModel> {
        return new EditCustomerView();
    }
    public getTypeId(): string {
        return "VM-F0A56D01-5A45-44B2-A839-FEA37BF35B61"
    }
    public set isLoading(v: boolean) { this._isLoading = v; } public get isLoading(): boolean { return this._isLoading; } private _isLoading: boolean;

    public set id(v: string) { this._id = v; } public get id(): string { return this._id; } private _id: string;
    public set name(v: string) { this._name = v; } public get name(): string { return this._name; } private _name: string;
    public set lastname(v: string) { this._lastname = v; } public get lastname(): string { return this._lastname; } private _lastname: string;
    public set customerCode(v: string) { this._customerCode = v; } public get customerCode(): string { return this._customerCode; } private _customerCode: string;
    public set comment(v: string) { this._comment = v; } public get comment(): string { return this._comment; } private _comment: string;
    public set nationalCode(v: string) { this._nationalCode = v; } public get nationalCode(): string { return this._nationalCode; } private _nationalCode: string;
    public set address(v: string) { this._address = v; } public get address(): string { return this._address; } private _address: string;

    public set provinceSelector(v: ProvinceSelectorViewModel) { this._provinceSelectorViewModel = v; } public get provinceSelector(): ProvinceSelectorViewModel { return this._provinceSelectorViewModel; } private _provinceSelectorViewModel: ProvinceSelectorViewModel;
    public set provinceId(v: string) { this._provinceId = v; } public get provinceId(): string { return this._provinceId; } private _provinceId: string;
    public set provinceName(v: string) { this._provinceName = v; } public get provinceName(): string { return this._provinceName; } private _provinceName: string;
    public set citySelector(v: CitySelectorViewModel) { this._citySelector = v; } public get citySelector(): CitySelectorViewModel { return this._citySelector; } private _citySelector: CitySelectorViewModel;
    public set cityId(v: string) { this._cityId = v; } public get cityId(): string { return this._cityId; } private _cityId: string;
    public set cityName(v: string) { this._cityName = v; } public get cityName(): string { return this._cityName; } private _cityName: string;
    public set attributeValues(v: ObservableArray<CustomerAttributeValue>) { this._attributeValues = v; } public get attributeValues(): ObservableArray<CustomerAttributeValue> { return this._attributeValues; } private _attributeValues: ObservableArray<CustomerAttributeValue>;
    public set monopolies(v: ObservableArray<MonopolyDistrict>) { this._monopolies = v; } public get monopolies(): ObservableArray<MonopolyDistrict> { return this._monopolies; } private _monopolies: ObservableArray<MonopolyDistrict>;
    public set isProvider(v: boolean) { this._isProvider = getAsBoolean(v); } public get isProvider(): boolean { return this._isProvider; } private _isProvider: boolean;
    public set parentCustomerSelector(v: SearchCustomerViewModel) { this._parentCustomerSelector = v; } public get parentCustomerSelector(): SearchCustomerViewModel { return this._parentCustomerSelector; } private _parentCustomerSelector: SearchCustomerViewModel;
    public set parentCustomerTitle(v: string) { this._parentCustomerTitle = v; } public get parentCustomerTitle(): string { return this._parentCustomerTitle; } private _parentCustomerTitle: string;
    public set hasParent(v: boolean) { this._hasParent = v;} public get hasParent(): boolean { return this._hasParent; } private _hasParent: boolean;

    public set phoneInput(v: PhoneInputViewModel) { this._phoneInput = v; } public get phoneInput(): PhoneInputViewModel { return this._phoneInput; } private _phoneInput: PhoneInputViewModel;
    private _typedParent: CustomerManipulationViewModel;

    cloneTo(customerEdit: Customer) {
        this.id = customerEdit.id;
        this.name = customerEdit.name;
        this.customerCode = customerEdit.customerCode;
        this.lastname = customerEdit.lastName;
        this.comment = customerEdit.comment;
        this.address = customerEdit.address;
        this.isProvider = customerEdit.isProvider;
        this.loadParent(customerEdit.parentId);
        this.setProvince(customerEdit.provinceId, customerEdit.provinceName);
        this.setCity(customerEdit.cityId, customerEdit.cityName);
        this.phoneInput.addCellPhone(...customerEdit.cellphones);
        this.phoneInput.addPhone(...customerEdit.phones);
        this.attributeValues.update(...customerEdit.attributeValues.map(x => {
            let p = new CustomerAttributeValue(this);
            p.assignmentId = x.assignmentId;
            p.attributeValueId = x.attributeValueId;
            p.attributeId = x.attributeId;
            p.attributeName = x.attributeName;
            p.name = x.name;
            p.edited = false;
            p.appliedFrom = moment.utc(x.appliedFrom);
            return p;
        }));
        this.monopolies.update(...customerEdit.monopolies.map(x => {
            let p = new MonopolyDistrict(this);
            p.id = x.id;
            p.name = x.name;
            return p;
        }));
    }
    async save() {
        try {
            // let verificationResult = this.verify();
            // if(verificationResult.length>0){
            //     let errorMessage = verificationResult.join('\n');
            //     await this.messageBoxConfirmWarning(errorMessage,'عدم امکان ثبت درخواست');
            //     return;
            // }
            this.isLoading = true;
            let phones = this.phoneInput.getPhones();
            let cellPhones = this.phoneInput.getCellPhones();
            let parentId = this.hasParent ? this.parentCustomerSelector.selectedItem?.id : null;
            let result = await ServerConnection.callServer('/Complex/CustomerServices/UpdateCustomer', {
                CustomerId: this.id,
                Name: this.name,
                LastName: this.lastname,
                NationalCode: this.nationalCode,
                Comment: this.comment,
                Address: this.address,
                IsProvider: this.isProvider,
                Province: this.getProvinceId(),
                City: this.getCityId(),
                ParentId :  parentId,
                Phones: phones.map((q, i) => {
                    return {
                        Index: i + 1,
                        CountryCode: q.countryCode,
                        CityCode: q.cityCode,
                        Number: q.number
                    }
                }),
                CellPhones: cellPhones.map((q, i) => {
                    return {
                        Index: i + 1,
                        CountryCode: q.countryCode,
                        Number: q.number
                    }
                }),
                AttributeValues: this.attributeValues.map(q => { return q.attributeValueId }),
                Monopolies: this.monopolies.map(q => { return q.id }),

            });
            if (result.IsSuccessful == false) {
                if (result.Faults[0].Parameters.FaultId === "F48EB25F-25DD-426C-B4F2-180F33075369")
                    throw "این شماره تماس قبلا تعریف شده است";
                throw "خطا در انجام عملیات";
            }
            await this.messageBoxConfirmSuccess('مشتری با موفقیت بروزرسانی شد.', 'عملیات موفق');
            this.closePopup("done")
        } catch (ex) {
            console.log(ex);
            await this.messageBoxConfirmWarning(ex, 'خطا');
        } finally {
            this.isLoading = false;
        }
    }

    verify(): string[] {
        let result: string[] = [];
        if (stringIsNullOrEmpty(this.name)) {
            result.push(' نام مشخص نشده است.')
        }
        if (stringIsNullOrEmpty(this.lastname)) {
            result.push(' نام خانوادگی مشخص نشده است.')
        }
        if (stringIsNullOrEmpty(this.getCityId())) {
            result.push(' شهر مشخص نشده است.')
        }
        if (stringIsNullOrEmpty(this.getProvinceId())) {
            result.push(' استان مشخص نشده است.')
        }
        if (this.phoneInput.getCellPhones().length <= 0) {
            result.push('حداقل یک شماره همراه باید ثبت شود.')
        }
        return result;
    }

    setProvince(id: string, name: string) {
        this.provinceSelector.selectById(id);
    }

    getProvinceId() {
        return this.provinceSelector.selectedItem?.id;
    }

    setCity(id: string, name: string) {
        this.citySelector.selectById(id);
    }

    getCityId() {
        return this.citySelector.selectedItem?.id;
    }

    removeMonopolies(district: MonopolyDistrict) {
        district.childDistricts.forEach(x => x.deleteMonopoly());
        this.monopolies.remove(district);
    }

    removeAttributeValue(attributeValue: CustomerAttributeValue) {
        this.attributeValues.remove(attributeValue);
    }

    loadParent(parentId:string){
        if(parentId != null){
            this.hasParent = true;
            this.parentCustomerSelector.selectById(parentId);
        }
    }
}

export class MonopolyDistrict extends ViewModel {
    public getTypeId(): string { return ''; }
    public GetDefaultView(): View<ViewModel> { return null; }
    constructor(parent: EditCustomerViewModel) {
        super(parent);
        this._typedParent = parent;
        this.childDistricts = ObservableArray.create<MonopolyDistrict>();
    }
    public set id(v: string) { this._id = v; } public get id(): string { return this._id; } private _id: string;
    public set name(v: string) { this._name = v; } public get name(): string { return this._name; } private _name: string;
    public set parentId(v: string) { this._parentId = v; } public get parentId(): string { return this._parentId; } private _parentId: string;
    public set parentName(v: string) { this._parentName = v; } public get parentName(): string { return this._parentName; } private _parentName: string;
    public set childDistricts(v: ObservableArray<MonopolyDistrict>) { this._childDistricts = v; } public get childDistricts(): ObservableArray<MonopolyDistrict> { return this._childDistricts; } private _childDistricts: ObservableArray<MonopolyDistrict>;
    public set selected(v: boolean) { this._selected = v; } public get selected(): boolean { return this._selected; } private _selected: boolean;
    private _typedParent: EditCustomerViewModel;

    async deleteMonopoly() {
        this._typedParent.removeMonopolies(this);
    }
}

export class CustomerAttributeValue extends ViewModel {
    public getTypeId(): string { return ''; }
    public GetDefaultView(): View<ViewModel> { return null; }
    constructor(parent: EditCustomerViewModel) {
        super(parent);
        this._typedParent = parent;
    }
    public set assignmentId(v: string) { this._assignmentId = v; } public get assignmentId(): string { return this._assignmentId; } private _assignmentId: string;
    public set name(v: string) { this._name = v; } public get name(): string { return this._name; } private _name: string;
    public set newName(v: string) { this._newName = v; } public get newName(): string { return this._newName; } private _newName: string;
    public set attributeId(v: string) { this._attributeId = v; } public get attributeId(): string { return this._attributeId; } private _attributeId: string;
    public set attributeName(v: string) { this._attributeName = v; } public get attributeName(): string { return this._attributeName; } private _attributeName: string;
    public set attributeValueId(v: string) { this._attributeValueId = v; } public get attributeValueId(): string { return this._attributeValueId; } private _attributeValueId: string;
    public set appliedFrom(v: moment.Moment) { this._appliedFrom = v; } public get appliedFrom(): moment.Moment { return this._appliedFrom; } private _appliedFrom: moment.Moment;
    public set selected(v: boolean) { this._selected = v; } public get selected(): boolean { return this._selected; } private _selected: boolean;
    public set edited(v: boolean) { this._edited = v; } public get edited(): boolean { return this._edited; } private _edited: boolean;
    public set isLoading(v: boolean) { this._isLoading = v; } public get isLoading(): boolean { return this._isLoading; } private _isLoading: boolean;
    private _typedParent: EditCustomerViewModel;

    async deleteAttributeValue() {
        this._typedParent.removeAttributeValue(this);
    }
}